import React from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import moment from 'moment'
import { Line, Bar } from 'react-chartjs-2'

import { white, azure, red, orange, blue, lineChartDataset, barChartDataset } from 'variables/chartSettings'

import miniMe from 'graphql/queries/miniMe'
import statsHomeRiepilogoContattiAppuntamenti from 'graphql/queries/statsHomeRiepilogoContattiAppuntamenti'
import statsHomeTableAgenti from 'graphql/queries/statsHomeTableAgenti'
import statsHomeLineChartAppuntamentiFissati from 'graphql/queries/statsHomeLineChartAppuntamentiFissati'
import statsHomeLineChartAppuntamentiAnno from 'graphql/queries/statsHomeLineChartAppuntamentiAnno'
import clienti from 'graphql/queries/clienti'
import appuntamentiPerStato from 'graphql/queries/appuntamentiPerStato'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import Table from 'material-ui/Table'
import TableHead from 'material-ui/Table/TableHead'
import TableCell from 'material-ui/Table/TableCell'
import TableBody from 'material-ui/Table/TableBody'
import TableRow from 'material-ui/Table/TableRow'
import IconButton from 'material-ui/IconButton'

// material-ui-icons
import DateRange from 'material-ui-icons/DateRange'
import PhoneForwarded from 'material-ui-icons/PhoneForwarded'
import Event from 'material-ui-icons/Event'
import Group from 'material-ui-icons/Group'
import Edit from 'material-ui-icons/Edit'
import AccessTime from 'material-ui-icons/AccessTime'
import RecentActors from 'material-ui-icons/RecentActors'
import ThumbUp from 'material-ui-icons/ThumbUp'

// core components
import RegularCard from 'components/Cards/RegularCard.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import StatsCard from 'components/Cards/StatsCard.jsx'
import ChartCard from 'components/Cards/ChartCard.jsx'
import IconCard from 'components/Cards/IconCard.jsx'
import NavPills from 'components/NavPills/NavPills.jsx'
import CalendarModalForm from 'components/CalendarModalForm/CalendarModalForm'
import Classifica from '../../../components/Classifica/Classifica'
import {
  PortalFilter,
  PortalIndicators,
  getPortalInterestFromFilter,
  getPortalsFromInterests,
  getStoredPortalFilter,
} from 'components/Portal/Portal.jsx'

import dashboardStyle from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle.jsx'
import './Home.css'

// HOME ADMIN - STATISTICHE
const TablePerformanceAgenti = (classes) => {
  return (
    <Query
      query={statsHomeTableAgenti}
      variables={{
        daData: moment().format('YYYY-MM-DD'),
        aData: moment().format('YYYY-MM-DD'),
      }}
      fetchPolicy="cache-and-network"
    >
      {({ loading, error, data }) => {
        if (loading) return <p>Loading...</p>
        if (error) return <p>Error :(</p>

        return (
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeadCell}>Nome</TableCell>
                <TableCell className={classes.tableHeadCell}>Contatti</TableCell>
                <TableCell className={classes.tableHeadCell}>Da rich.</TableCell>
                <TableCell className={classes.tableHeadCell}>Tel</TableCell>
                <TableCell className={classes.tableHeadCell}>Whatsapp</TableCell>
                <TableCell className={classes.tableHeadCell}>Email</TableCell>
                <TableCell className={classes.tableHeadCell}>App. fissati</TableCell>
                <TableCell className={classes.tableHeadCell}>App. conf. segretaria</TableCell>
                <TableCell className={classes.tableHeadCell}>App. da fare</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.statsHomeTableAgenti.map((performance) => (
                <TableRow key={performance.nomeAgente}>
                  <TableCell className={classes.tableCell}>{performance.nomeAgente}</TableCell>
                  <TableCell className={classes.tableCell}>
                    <span className={classes.success}>{performance.numeroContattiInCuiHaFattoAzioni}</span>/<span>{performance.numeroContattiRicevuti}</span>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <span className={classes.danger}>{performance.numeroContattiDaRichiamare}</span>
                  </TableCell>
                  <TableCell className={classes.tableCell}>{performance.numeroTelefonateOut}</TableCell>
                  <TableCell className={classes.tableCell}>{performance.numeroWhatsappOut}</TableCell>
                  <TableCell className={classes.tableCell}>{performance.numeroEmailOut}</TableCell>
                  <TableCell className={classes.tableCell}>{performance.numeroAppuntamentiFissati}</TableCell>
                  <TableCell className={classes.tableCell}>{performance.numeroAppuntamentiConfermatiSegretaria}</TableCell>
                  <TableCell className={classes.tableCell}>{performance.numeroAppuntamentiDaFare}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )
      }}
    </Query>
  )
}

const appuntamentiFissatiSettimanaOptions = {
  maintainAspectRatio: false,
  xAxes: [
    {
      type: 'time',
      time: {
        displayFormats: {
          day: 'ddd',
        },
      },
    },
  ],
  scales: {
    xAxes: [
      {
        gridLines: {
          color: 'hsla(0, 100%, 100%, 0.2)',
        },
        ticks: {
          fontColor: '#fff',
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          color: 'hsla(0, 100%, 100%, 0.2)',
        },
        ticks: {
          fontColor: '#fff',
          beginAtZero: true,
          min: 0,
          //max: 100
        },
      },
    ],
  },
  legend: {
    display: false,
    position: 'bottom',
  },
  layout: {
    padding: {
      top: 20,
      right: 20,
      bottom: 10,
      left: 0,
    },
  },
}

const appuntamentiAnnoOptions = {
  maintainAspectRatio: false,
  xAxes: [
    {
      type: 'time',
      time: {
        displayFormats: {
          month: 'MMM',
        },
      },
    },
  ],
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      boxWidth: 13,
      padding: 20,
    },
  },
  layout: {
    padding: {
      top: 30,
      right: 20,
      bottom: 10,
      left: 0,
    },
  },
}

// HOME SEGRETARIE - APPUNTAMENTI DA CONFERMARE SEGRETARIA E CLIENTE

// HOME AGENTI - TABELLA CLIENTI DA RICONTATTARE
const TableClienti = (props) => {
  const { classes, portalFilter } = props
  const where = {
    daRicontattare: true,
    telNonRisposte: 0,
  }
  const portalInterest = getPortalInterestFromFilter(portalFilter)

  if (portalInterest) where.interessi_any = { nome: portalInterest }

  return (
    <Query
      query={clienti}
      variables={{
        limit: 50,
        offset: 0,
        where,
        orderBy: ['dataUltimaRichiesta_DESC'],
      }}
      fetchPolicy="cache-and-network"
    >
      {({ loading, error, data }) => {
        if (loading) return <p>Loading...</p>
        if (error) return <p>Error :(</p>

        if (data.clienti.totalCount === 0 && portalInterest) {
          return (
            <div style={{ padding: '30px 15px', textAlign: 'center' }}>
              <h3>Nessun cliente trovato</h3>
              <h4>Non ci sono clienti da ricontattare per il portale selezionato</h4>
            </div>
          )
        }

        return data.clienti.totalCount > 0 ? (
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeadCell}>Portale</TableCell>
                <TableCell className={classes.tableHeadCell}>Nome</TableCell>
                <TableCell className={classes.tableHeadCell}>Comune</TableCell>
                <TableCell className={classes.tableHeadCell}>Data ultimo contatto</TableCell>
                <TableCell className={classes.tableHeadCell}>Data ultima richiesta</TableCell>
                <TableCell className={classes.tableHeadCell}>Email</TableCell>
                <TableCell className={classes.tableHeadCell}>Telefono</TableCell>
                <TableCell className={classes.tableHeadCell}>Agente</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.clienti.nodes.map((cliente) => (
                <TableRow key={cliente.id}>
                  <TableCell className={classes.tableCell}>
                    <PortalIndicators portals={getPortalsFromInterests(cliente.interessi)} />
                  </TableCell>
                  <TableCell className={classes.tableCell} style={{ fontWeight: cliente.daRicontattare ? 'bold' : 'normal' }}>
                    <Link to={`/clienti/${cliente.id}`} style={{ color: cliente.nuovoClienteFlag ? '#2ab32a' : 'auto' }}>
                      {cliente.nome ? cliente.nome : <i>Senza nome</i>}
                    </Link>
                  </TableCell>
                  <TableCell className={classes.tableCell}>{cliente.comune}</TableCell>
                  <TableCell className={classes.tableCell}>{cliente.dataUltimoContatto ? moment(cliente.dataUltimoContatto).format('DD/MM/YYYY HH:mm') : ''}</TableCell>
                  <TableCell className={classes.tableCell}>{cliente.dataUltimaRichiesta ? moment(cliente.dataUltimaRichiesta).format('DD/MM/YYYY') : 'Nessuna richiesta'}</TableCell>
                  <TableCell className={classes.tableCell}>
                    <a href={`mailto:${cliente.email}`}>{cliente.email}</a>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <a href={`tel:${cliente.telefono}`}>{cliente.telefono}</a>
                  </TableCell>
                  <TableCell className={classes.tableCell}>{cliente.agente ? cliente.agente.nome : <i>Senza agente</i>}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="success-message">
            <ThumbUp />
            <h3>Congratulazioni!</h3>
            <h4>Hai ricontattato tutti i tuoi clienti</h4>
          </div>
        )
      }}
    </Query>
  )
}

// HOME
class Home extends React.Component {
  // SEGRETARIA
  constructor(props) {
    super(props)

    this.state = {
      eventsType: 'home-segretaria',
      showModal: false,
      initialValues: {},
      isNewEvent: true,
      error: '',
      portalFilter: getStoredPortalFilter(),
    }
  }

  handleChangePortalFilter = (portalFilter) => {
    this.setState({ portalFilter })
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      initialValues: {},
      error: '',
    })
  }

  setErrorMessage = (errorMessage) => {
    this.setState({
      error: errorMessage,
    })
  }

  editAction = (azione) => (event) => {
    event.preventDefault()

    const initialValues = {
      id: azione.id,
      tipoEvento: azione.tipoAzione.tipo,
      start: moment(azione.appuntamentoDaDataOra).toDate(),
      end: moment(azione.appuntamentoADataOra).toDate(),
      agenteId: azione.appuntamentoAgenteId,
      clienteId: azione.clienteId,
      luogo: azione.appuntamentoLuogo,
      appuntamentoOrigine: azione.appuntamentoOrigine,
      stato: azione.appuntamentoStato,
      descrizione: azione.descrizione,
      dataOra: moment(azione.dataOra).toDate(),
      title: `Modifica ${azione.tipoAzione.tipo}`,
    }

    this.setState({
      showModal: true,
      initialValues: initialValues,
      isNewEvent: false,
    })
  }

  setClassificaTipo = (tipo) => this.setState({ classificaTipo: tipo })

  // TUTTI
  render() {
    const { classes } = this.props

    const { eventsType, showModal, initialValues, isNewEvent, classificaTipo } = this.state

    return (
      <Query query={miniMe}>
        {({ loading, error, data: { me } }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>

          return (
            <div>
              {(me.ruolo === 'ADMIN' || me.mostraStatisticheAgenti) && (
                // HOME ADMIN
                <div className="home home-admin">
                  <Query
                    query={statsHomeRiepilogoContattiAppuntamenti}
                    variables={{
                      daData: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                      aData: moment().format('YYYY-MM-DD'),
                    }}
                    fetchPolicy="cache-and-network"
                  >
                    {({ loading, error, data }) => {
                      if (loading) return <p>Loading...</p>
                      if (error) return <p>Error :(</p>

                      return (
                        <GridContainer>
                          <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <StatsCard icon={RecentActors} iconColor="blue" title="Contatti" description={data.statsHomeRiepilogoContattiAppuntamenti.numeroContatti} statIcon={AccessTime} statText="Dati ultimi 30 giorni" />
                          </ItemGrid>
                          <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <StatsCard icon={PhoneForwarded} iconColor="green" title="Da richiamare" description={data.statsHomeRiepilogoContattiAppuntamenti.numeroContattiSenzaRisposta} statIcon={AccessTime} statText="Dati ultimi 30 giorni" />
                          </ItemGrid>
                          <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <StatsCard icon={DateRange} iconColor="orange" title="App. fissati" description={data.statsHomeRiepilogoContattiAppuntamenti.numeroAppuntamentiFissati} statIcon={AccessTime} statText="Dati ultimi 30 giorni" />
                          </ItemGrid>
                          <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <StatsCard icon={Event} iconColor="red" title="Da confermare" description={data.statsHomeRiepilogoContattiAppuntamenti.numeroAppuntamentiDaConfermare} statIcon={AccessTime} statText="Dati ultimi 30 giorni" />
                          </ItemGrid>
                        </GridContainer>
                      )
                    }}
                  </Query>

                  <GridContainer>
                    <ItemGrid xs={12} lg={6}>
                      <IconCard icon={Group} title="Attività agenti oggi" iconColor="green" content={TablePerformanceAgenti(classes)} />
                    </ItemGrid>
                    <ItemGrid xs={12} lg={6}>
                      <Query
                        query={statsHomeLineChartAppuntamentiFissati}
                        variables={{
                          data: moment().format('YYYY-MM-DD'),
                        }}
                        fetchPolicy="cache-and-network"
                      >
                        {({ loading, error, data }) => {
                          if (loading) return <p>Loading...</p>
                          if (error) return <p>Error :(</p>

                          return (
                            <ChartCard
                              chart={
                                <div className="chart-container" style={{ height: 300 }}>
                                  <Line
                                    data={{
                                      labels: data.statsHomeLineChartAppuntamentiFissati.map((appuntamento) => {
                                        return moment(appuntamento.data).format('ddd')
                                      }),
                                      datasets: [
                                        lineChartDataset(
                                          'App. fissati',
                                          true,
                                          `hsla(${white}, 0.4)`,
                                          `hsla(${white}, 1)`,
                                          data.statsHomeLineChartAppuntamentiFissati.map((appuntamento) => {
                                            return appuntamento.numero
                                          })
                                        ),
                                      ],
                                    }}
                                    options={appuntamentiFissatiSettimanaOptions}
                                  />
                                </div>
                              }
                              chartColor="blue"
                              title="Appuntamenti fissati della settimana"
                              statIcon={AccessTime}
                              statText="dati ultimi 7 giorni"
                            />
                          )
                        }}
                      </Query>

                      <Classifica me={me} />
                    </ItemGrid>
                  </GridContainer>

                  <GridContainer>
                    <ItemGrid xs={12}>
                      <Query query={statsHomeLineChartAppuntamentiAnno} fetchPolicy="cache-and-network">
                        {({ loading, error, data }) => {
                          if (loading) return <p>Loading...</p>
                          if (error) return <p>Error :(</p>

                          return (
                            <ChartCard
                              chart={
                                <div className="chart-container" style={{ height: 300 }}>
                                  <Bar
                                    data={{
                                      labels: data.statsHomeLineChartAppuntamentiAnno.map((andamento) => {
                                        return moment(`${andamento.anno}-${andamento.mese}-02`, 'YYYY-MM-DD').format('MMM')
                                      }),
                                      datasets: [
                                        barChartDataset(
                                          'Creati',
                                          `hsla(${azure}, 1)`,
                                          `hsla(${azure}, 1)`,
                                          data.statsHomeLineChartAppuntamentiAnno.map((andamento) => {
                                            return andamento.numeroCreati
                                          })
                                        ),
                                        barChartDataset(
                                          'Confermati segretaria',
                                          `hsla(${red}, 1)`,
                                          `hsla(${red}, 1)`,
                                          data.statsHomeLineChartAppuntamentiAnno.map((andamento) => {
                                            return andamento.numeroConfermatiSegretaria
                                          })
                                        ),
                                        barChartDataset(
                                          'Confermati cliente',
                                          `hsla(${orange}, 1)`,
                                          `hsla(${orange}, 1)`,
                                          data.statsHomeLineChartAppuntamentiAnno.map((andamento) => {
                                            return andamento.numeroConfermatiCliente
                                          })
                                        ),
                                        barChartDataset(
                                          'Fatti',
                                          `hsla(${blue}, 1)`,
                                          `hsla(${blue}, 1)`,
                                          data.statsHomeLineChartAppuntamentiAnno.map((andamento) => {
                                            return andamento.numeroFatti
                                          })
                                        ),
                                      ],
                                    }}
                                    options={appuntamentiAnnoOptions}
                                  />
                                </div>
                              }
                              chartColor="gray"
                              title="Appuntamenti dell'anno"
                              statIcon={AccessTime}
                              statText="dati ultimi 13 mesi"
                            />
                          )
                        }}
                      </Query>
                    </ItemGrid>
                  </GridContainer>
                </div>
              )}

              {me.ruolo === 'SEGRETARIA' && (
                // HOME SEGRETARIA
                <div className="home home-segretaria">
                  {!me.mostraStatisticheAgenti && (
                    <div style={{ marginBottom: '40px' }}>
                      <Classifica me={me} />
                    </div>
                  )}
                  <NavPills
                    color="warning"
                    tabs={[
                      // DA CONFERMARE SEGRETARIA
                      {
                        tabButton: 'Appuntamenti da confermare',
                        tabContent: (
                          <Query
                            query={appuntamentiPerStato}
                            variables={{
                              limit: 500,
                              stato: 'FISSATO_AGENTE',
                              daData: moment().subtract(10, 'days').format('YYYY-MM-DD'),
                              aData: moment().add(100, 'days').format('YYYY-MM-DD'),
                            }}
                            fetchPolicy="cache-and-network"
                          >
                            {({ loading, error, data }) => {
                              if (loading) return <p>Loading...</p>
                              if (error) return <p>Error :(</p>

                              return (
                                <RegularCard
                                  cardTitle={<h3>Appuntamenti da confermare</h3>}
                                  content={
                                    data.azioni.totalCount === 0 ? (
                                      <div className="success-message">
                                        <ThumbUp />
                                        <h3>Congratulazioni!</h3>
                                        <h4>Hai gestito tutti gli appuntamenti</h4>
                                      </div>
                                    ) : (
                                      <div>
                                        <Table className={classes.table}>
                                          <TableHead>
                                            <TableRow>
                                              <TableCell className={classes.tableHeadCell}>Data</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Ora</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Luogo</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Agente</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Cliente</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Telefono</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Email</TableCell>
                                              <TableCell className={classes.tableHeadCell}></TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {data.azioni.nodes.map((azione) => (
                                              <TableRow key={azione.id}>
                                                <TableCell className={classes.tableCell}>{moment(azione.appuntamentoDaDataOra).format('DD/MM/YYYY')}</TableCell>
                                                <TableCell className={classes.tableCell}>{moment(azione.appuntamentoDaDataOra).format('HH:mm')}</TableCell>
                                                <TableCell className={classes.tableCell}>{azione.appuntamentoLuogo}</TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <Link to={`/agenti/${azione.appuntamentoAgente.id}`}>{azione.appuntamentoAgente ? azione.appuntamentoAgente.nome : <i>Senza agente</i>}</Link>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <Link to={`/clienti/${azione.cliente.id}`}>{azione.cliente.nome ? azione.cliente.nome : <i>Senza nome</i>}</Link>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <a href={`tel:${azione.cliente.telefono}`}>{azione.cliente.telefono}</a>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <a href={`mailto:${azione.cliente.email}`}>{azione.cliente.email}</a>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <IconButton
                                                    color="primary"
                                                    style={{
                                                      float: 'right',
                                                      fontSize: '16px',
                                                      width: 20,
                                                      height: 20,
                                                    }}
                                                    onClick={this.editAction(azione)}
                                                  >
                                                    <Edit />
                                                  </IconButton>
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                        <CalendarModalForm eventsType={eventsType} initialValues={initialValues} isNewEvent={isNewEvent} open={!!showModal} onCloseModal={this.closeModal} onSetErrorMessage={this.setErrorMessage} isAgente={false} />
                                      </div>
                                    )
                                  }
                                />
                              )
                            }}
                          </Query>
                        ),
                      },
                      // PROX DA CONFERMARE CLIENTE
                      {
                        tabButton: 'Prossimi appuntamenti da confermare cliente',
                        tabContent: (
                          <Query
                            query={appuntamentiPerStato}
                            variables={{
                              limit: 500,
                              stato: 'CONFERMATO_SEGRETARIA',
                              daData: moment().format('YYYY-MM-DD'),
                              aData: moment().add(10, 'days').format('YYYY-MM-DD'),
                            }}
                            fetchPolicy="cache-and-network"
                          >
                            {({ loading, error, data }) => {
                              if (loading) return <p>Loading...</p>
                              if (error) return <p>Error :(</p>

                              return (
                                <RegularCard
                                  cardTitle={<h3>Prossimi appuntamenti da confermare cliente</h3>}
                                  content={
                                    data.azioni.totalCount === 0 ? (
                                      <h4>Nessun appuntamento da confermare</h4>
                                    ) : (
                                      <div>
                                        <Table className={classes.table}>
                                          <TableHead>
                                            <TableRow>
                                              <TableCell className={classes.tableHeadCell}>Data</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Ora</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Luogo</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Agente</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Cliente</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Telefono</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Email</TableCell>
                                              <TableCell className={classes.tableHeadCell}></TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {data.azioni.nodes.map((azione) => (
                                              <TableRow key={azione.id}>
                                                <TableCell className={classes.tableCell}>{moment(azione.appuntamentoDaDataOra).format('DD/MM/YYYY')}</TableCell>
                                                <TableCell className={classes.tableCell}>{moment(azione.appuntamentoDaDataOra).format('HH:mm')}</TableCell>
                                                <TableCell className={classes.tableCell}>{azione.appuntamentoLuogo}</TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <Link to={`/agenti/${azione.appuntamentoAgente.id}`}>{azione.appuntamentoAgente ? azione.appuntamentoAgente.nome : <i>Senza agente</i>}</Link>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <Link to={`/clienti/${azione.cliente.id}`}>{azione.cliente.nome ? azione.cliente.nome : <i>Senza nome</i>}</Link>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <a href={`tel:${azione.cliente.telefono}`}>{azione.cliente.telefono}</a>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <a href={`mailto:${azione.cliente.email}`}>{azione.cliente.email}</a>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <IconButton
                                                    color="primary"
                                                    style={{
                                                      float: 'right',
                                                      fontSize: '16px',
                                                      width: 20,
                                                      height: 20,
                                                    }}
                                                    onClick={this.editAction(azione)}
                                                  >
                                                    <Edit />
                                                  </IconButton>
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                        <CalendarModalForm eventsType={eventsType} initialValues={initialValues} isNewEvent={isNewEvent} open={!!showModal} onCloseModal={this.closeModal} onSetErrorMessage={this.setErrorMessage} isAgente={false} />
                                      </div>
                                    )
                                  }
                                />
                              )
                            }}
                          </Query>
                        ),
                      },
                      // CONFERMATI CLIENTE (DA FARE)
                      {
                        tabButton: 'Appuntamenti confermati dal cliente',
                        tabContent: (
                          <Query
                            query={appuntamentiPerStato}
                            variables={{
                              limit: 500,
                              stato: 'CONFERMATO_CLIENTE',
                              daData: moment().format('YYYY-MM-DD'),
                              aData: moment().add(10, 'days').format('YYYY-MM-DD'),
                            }}
                            fetchPolicy="cache-and-network"
                          >
                            {({ loading, error, data }) => {
                              if (loading) return <p>Loading...</p>
                              if (error) return <p>Error :(</p>

                              return (
                                <RegularCard
                                  cardTitle={<h3>Appuntamenti confermati dal cliente</h3>}
                                  content={
                                    data.azioni.totalCount === 0 ? (
                                      <h4>Nessun appuntamento confermato da cliente</h4>
                                    ) : (
                                      <div>
                                        <Table className={classes.table}>
                                          <TableHead>
                                            <TableRow>
                                              <TableCell className={classes.tableHeadCell}>Data</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Ora</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Luogo</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Agente</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Cliente</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Telefono</TableCell>
                                              <TableCell className={classes.tableHeadCell}>Email</TableCell>
                                              <TableCell className={classes.tableHeadCell}></TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {data.azioni.nodes.map((azione) => (
                                              <TableRow key={azione.id}>
                                                <TableCell className={classes.tableCell}>{moment(azione.appuntamentoDaDataOra).format('DD/MM/YYYY')}</TableCell>
                                                <TableCell className={classes.tableCell}>{moment(azione.appuntamentoDaDataOra).format('HH:mm')}</TableCell>
                                                <TableCell className={classes.tableCell}>{azione.appuntamentoLuogo}</TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <Link to={`/agenti/${azione.appuntamentoAgente.id}`}>{azione.appuntamentoAgente ? azione.appuntamentoAgente.nome : <i>Senza agente</i>}</Link>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <Link to={`/clienti/${azione.cliente.id}`}>{azione.cliente.nome ? azione.cliente.nome : <i>Senza nome</i>}</Link>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <a href={`tel:${azione.cliente.telefono}`}>{azione.cliente.telefono}</a>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <a href={`mailto:${azione.cliente.email}`}>{azione.cliente.email}</a>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                  <IconButton
                                                    color="primary"
                                                    style={{
                                                      float: 'right',
                                                      fontSize: '16px',
                                                      width: 20,
                                                      height: 20,
                                                    }}
                                                    onClick={this.editAction(azione)}
                                                  >
                                                    <Edit />
                                                  </IconButton>
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                        <CalendarModalForm eventsType={eventsType} initialValues={initialValues} isNewEvent={isNewEvent} open={!!showModal} onCloseModal={this.closeModal} onSetErrorMessage={this.setErrorMessage} isAgente={false} />
                                      </div>
                                    )
                                  }
                                />
                              )
                            }}
                          </Query>
                        ),
                      },
                    ]}
                  />
                </div>
              )}

              {me.ruolo === 'AGENTE' && (
                // HOME AGENTE
                <div className="home home-agente">
                  {!me.mostraStatisticheAgenti && <Classifica me={me} />}
                  <GridContainer>
                    <ItemGrid xs={12}>
                      <IconCard
                        icon={RecentActors}
                        iconColor="blue"
                        title="Clienti da ricontattare"
                        filter={
                          <PortalFilter value={this.state.portalFilter} onChange={this.handleChangePortalFilter} style={{ width: 210, maxWidth: '100%', margin: '0 0 15px auto' }} />
                        }
                        content={
                          <div>
                            <TableClienti classes={classes} portalFilter={this.state.portalFilter} />
                          </div>
                        }
                      />
                    </ItemGrid>
                  </GridContainer>
                </div>
              )}
            </div>
          )
        }}
      </Query>
    )
  }
}

export default withStyles(dashboardStyle)(Home)



// WEBPACK FOOTER //
// ./src/views/App/Home/Home.jsx